<template>
  <popup-modal ref="popup">
    <DialogCloseButton :close-method="closeDialog" />

    <h2 class="font-weight-bold title content">
      {{ $t('UPDATE_STATUS_CONFIRMATION_MODAL.TITLE') }}
    </h2>

    <div class="mt-8 mb-4 content">
      <p class="sub-title">
        {{ $t('UPDATE_STATUS_CONFIRMATION_MODAL.MESSAGE') }}
      </p>
    </div>

    <div class="mb-4 content">
      <p class="sub-message">
        {{ $t('UPDATE_STATUS_CONFIRMATION_MODAL.SUB_MESSAGE') }}
      </p>
    </div>

    <v-form ref="formChangeStatus" @submit.prevent="saveAndClose" v-model="formValid">
      <v-col cols="4" class="d-flex justify-left pa-0 mb-2">
        <div class="d-flex align-center">
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ props }">
              <img
                v-bind="props"
                alt="export"
                class="date-picker"
                src="@/assets/icons/repair-file-list/date.svg"
                @click="showValidDate = true"
              />
              <v-text-field
                v-bind="props"
                class="ml-3 date-creation"
                v-model="realUpdatingDate"
                :value="formatDate()"
                readonly
                hide-details
                @click="showValidDate = true"
              />
              <v-icon
                icon="mdi-check-circle-outline"
                color="#767676"
                class="update-icon"
                v-if="showValidDate"
                @click="showValidDate = false"
              />
            </template>
            <v-locale-provider locale="fr">
              <v-date-picker
                v-model="realUpdatingDate"
                hide-header
                color="#559A1B"
                locale="fr"
                :max="today"
              />
            </v-locale-provider>
          </v-menu>
        </div>
      </v-col>

      <v-row>
        <v-col>
          <v-btn
            class="boom-button dialog-button"
            variant="outlined"
            :disabled="loading || !formValid"
            type="submit"
            :loading="loading"
          >
            {{ $t('COMMON.BUTTON.VALIDATE') }}
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            class="boom-button-back dialog-button"
            variant="outlined"
            @click="closeDialog()"
            :loading="loading"
          >
            {{ $t('COMMON.BUTTON.CANCEL') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </popup-modal>
</template>

<script>
import PopupModal from '@/components/modal/PopupModal.vue'
import {
  handleResponseError,
  shouldShowTooltip
} from '@/components/utils/globalFunction'
import RentalFileService from '@/services/rentalModule/RentalFileService'
import { auth as $store } from '@/store/AuthModule'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'UpdateStatusClientInformedModal',
  components: { DialogCloseButton, PopupModal },
  data() {
    const date = new Date()
    date.setDate(date.getDate())
    date.setHours(0, 0, 0, 0)

    return {
      formValid: false,
      loading: false,

      currentRentalFile: null,

      realUpdatingDate: date,
      today: new Date(),

      showValidDate: false,
    }
  },
  methods: {
    shouldShowTooltip,
    formatDate() {
      const date = this.realUpdatingDate
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    async show(opts = {}) {
      this.currentRentalFile = opts.currentRentalFile
      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    async saveAndClose() {
      try {
        await RentalFileService.updateRentalFileStatusToClientInformed(
          this.currentRentalFile.rental_file_technical_id,
          this.realUpdatingDate,
          $store.state.currentCollaborator.technical_id
        )
        this.resetDate()
        this.$refs.popup.close()
        this.resolvePromise(true)
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    closeDialog() {
      this.loading = false
      this.$refs.popup.close()
      this.resolvePromise(false)
      this.resetDate()
    },
    resetDate() {
      const date = new Date()
      date.setDate(date.getUTCDate())
      date.setHours(0, 0, 0, 0)
      this.realUpdatingDate = date
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.content {
  display: flex;
  justify-content: center;
}

.dialog-button {
  min-width: 100px;
  width: 100%;
}

.sub-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.sub-message {
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.date-picker {
  width: 16px;
  filter: invert(48%) sepia(0%) saturate(78%) hue-rotate(135deg) brightness(95%) contrast(83%);
}

.date-creation {
  display: flex;
  justify-items: center;
  color: #767676;
  padding: 4px;
  min-width: 125px;
}

:deep(.v-input__control) {
  min-width: 125px;
}

.date-picker,
.date-creation {
  cursor: pointer;
}
</style>
